module.exports = __webpack_public_path__ + "img/product_74.a4e393a.webp";